const { getElement } = window.BAO.Utils

class ContentTakeover extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.loading = false
  }

  setupListeners () {
    super.setupListeners()

    this.updatePage = this.updatePage.bind(this)

    if (this.els.toggle) {
      this.listeners.add(this.els.toggle.element, 'change', this.updatePage)
    }
  }

  async updatePage () {
    this.classList.toggle('hd-Takeover-active', this.state)
    this.loading = true

    try {
      const response = await fetch(this.url)
      const data = await response.text()

      const parser = new DOMParser()
      const doc = parser.parseFromString(data, 'text/html')

      const main = getElement(this.externalEls.main.selector, {
        context: doc,
      })

      if (!main) {
        throw new Error('Main content element not found in fetched page')
      }

      this.externalEls.main.element.innerHTML = main.innerHTML
      await new Promise(resolve => setTimeout(resolve, 1000))
    } catch (error) {
      console.error('Error updating page:', error)
    } finally {
      this.loading = false
    }
  }

  async fetchHtml () {
    try {
      const response = await fetch('./file.html')
      const html = await response.text()
      document.body.innerHTML = html
    } catch (error) {
      console.error('Error fetching HTML:', error)
    }
  }

  get state () {
    return this.els.toggle.element.checked
  }

  get url () {
    return this.state ? this.getAttribute('data-page') : '/'
  }

  get loading () {
    return this.getAttribute('aria-busy') === 'true'
  }

  set loading (val) {
    this.setAttribute('aria-busy', val.toString())
  }
}

if (!customElements.get('content-takeover')) {
  customElements.define('content-takeover', ContentTakeover)
}
